import React from 'react';
import { StyledBannerWrapper, LogoWrapper, ContentWrapper, Spacer } from './messageBanner.styles';
import WirewaxNameLogo from '../../assets/wirewax-name-logo';

const MessageBanner = ({ show, children, whitelabel }) => {
    return (
        <StyledBannerWrapper show={show} color="white">
            <ContentWrapper>
                {!whitelabel && (
                    <LogoWrapper
                        onClick={() => window.open('https://www.wirewax.com/?ref=embedder')}
                    >
                        <WirewaxNameLogo />
                    </LogoWrapper>
                )}
                <Spacer width={10} />
                {children}
            </ContentWrapper>
        </StyledBannerWrapper>
    );
};

export default MessageBanner;
